<template>
    <div>
        <!-- <base-navigation></base-navigation> -->
    
    <div class="homepage">
      <!-- Hero Section -->
      <section class="hero">
        <div class="hero-overlay">
          <h1>RaiseTrack</h1>
          <p>Smarter way to manage fundraising.</p>
          <button @click="goToDemo" class="hero-btn">See demo</button>
          <br>
          <br>
          <button @click="goTosignup" class="hero-btn">sign in  or Create an account</button>
        </div>
      </section>
  
      <!-- Features Section -->
      <section class="features">
        <h2>What Makes RaiseTrack Unique?</h2>
        <div class="features-grid">
          <div class="feature-item">
            <img src="assets/icons/secure.png" alt="Secure" />
            <h3>Secure</h3>
            <p>Keep your funds safe with our trusted platform.</p>
          </div>
          <div class="feature-item">
            <img src="assets/icons/easy.png" alt="Easy to Use" />
            <h3>Easy to Use</h3>
            <p>Manage campaigns with just a few clicks.</p>
          </div>
          <div class="feature-item">
            <img src="assets/icons/reporting.png" alt="Comprehensive Reports" />
            <h3>Comprehensive Reports</h3>
            <p>Track contributions and generate detailed reports.</p>
          </div>
          <div class="feature-item">
            <img src="assets/icons/teamwork.png" alt="Collaborative" />
            <h3>Collaborative</h3>
            <p>Copy the contribution list and share on your whatsapp group.</p>
          </div>
        </div>
      </section>
  
      <!-- How It Works -->
      <section class="how-it-works">
        <h2>How RaiseTrack Works</h2>
        <div class="steps">
          <div class="step">
            <span>1</span>
            <h3>Create an Account</h3>
            <p>Sign up to start managing your campaigns.</p>
          </div>
          <div class="step">
            <span>2</span>
            <h3>Set Up Your Campaign</h3>
            <p>Provide details and launch your fundraising effort.</p>
          </div>
          <div class="step">
            <span>3</span>
            <h3>Monitor Contributions</h3>
            <p>Track funds and generate reports in real-time.</p>
          </div>
        </div>
      </section>
  
      <!-- Testimonials -->
      <section class="testimonials">
        <h2>What Our Users Say</h2>
        <div class="testimonials-grid">
          <div class="testimonial">
            <p>"RaiseTrack transformed how we manage community funds. It's simple and transparent!"</p>
            <strong>– Levy Molel</strong>
          </div>
          <div class="testimonial">
            <p>"A fantastic tool for fundraising. The reports and collaboration features are a game-changer."</p>
            <strong>– Benard</strong>
          </div>
        </div>
      </section>
  
      <!-- Footer -->
      <footer>
        <div class="footer-content">
          <p>&copy; 2024 RaiseTrack. All rights reserved.</p>
          <nav>
            <a href="#terms">Terms</a>
            <a href="#privacy">Privacy</a>
            <a href="#contact">Contact</a>
          </nav>
        </div>
      </footer>
    </div>
</div>
  </template>
  
  <script>
  export default {
    name: "HomePage",
    methods: {
      goToDemo() {
        this.$router.push("/collections");
      },
      goTosignup() {
        this.$router.push("/login");
      },
    },
  };
  </script>
  
  <style scoped>
  /* Hero Section */
  .hero {
    position: relative;
    height: 100vh;
    background: url('../../assets/images/hero-bg.jpg') no-repeat center center/cover;
  }
  
  .hero-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: white;
    text-align: center;
  }
  
  .hero h1 {
    font-size: 3rem;
    margin-bottom: 10px;
  }
  
  .hero p {
    font-size: 1.2rem;
    margin-bottom: 20px;
  }
  
  .hero-btn {
    background: #34a853;
    color: white;
    padding: 10px 20px;
    border-radius: 5px;
    border: none;
    cursor: pointer;
  }
  
  /* Features Section */
  .features {
    padding: 60px 20px;
    text-align: center;
    background: #f9f9f9;
  }
  
  .features-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 20px;
  }
  
  .feature-item {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  .feature-item img {
    width: 50px;
    margin-bottom: 10px;
  }
  
  /* How It Works Section */
  .how-it-works {
    padding: 60px 20px;
    text-align: center;
  }
  
  .steps {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  
  .step {
    max-width: 300px;
    margin: 20px;
  }
  
  .step span {
    background: #34a853;
    color: white;
    padding: 10px 20px;
    border-radius: 50%;
    display: inline-block;
    margin-bottom: 10px;
  }
  
  /* Testimonials */
  .testimonials {
    padding: 60px 20px;
    text-align: center;
    background: #fff;
  }
  
  .testimonials-grid {
    display: flex;
    justify-content: center;
    gap: 20px;
  }
  
  .testimonial {
    max-width: 300px;
    background: #f9f9f9;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  }
  
  /* Footer */
  footer {
    padding: 20px;
    text-align: center;
    background: #333;
    color: white;
  }
  
  footer nav a {
    margin: 0 10px;
    color: white;
    text-decoration: none;
  }
  </style>
  